"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsPages = void 0;
var react_1 = __importDefault(require("react"));
var _ = __importStar(require("lodash"));
var settings_icon_svg_1 = __importDefault(require("res/img/settings-icon.svg"));
var SettingsPages;
(function (SettingsPages) {
    SettingsPages["GENERAL"] = "generalSettings";
})(SettingsPages = exports.SettingsPages || (exports.SettingsPages = {}));
var SettingsMenu = function (_a) {
    var page = _a.page, onChangePage = _a.onChangePage;
    return (react_1.default.createElement("ul", { className: 'settings-menu', role: 'menu' },
        react_1.default.createElement("li", { className: 'flex flex-row', "aria-selected": page === SettingsPages.GENERAL, onClick: function () { return onChangePage(SettingsPages.GENERAL); }, role: 'menuitem' },
            react_1.default.createElement("img", { src: settings_icon_svg_1.default, alt: "" + _.startCase(SettingsPages.GENERAL) }),
            react_1.default.createElement("span", null, _.startCase(SettingsPages.GENERAL)))));
};
exports.default = SettingsMenu;
